// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3AGHC","label":"CategoryService_label__1tD-U","location":"CategoryService_location__3IK0f"};